import axios from "axios";

export const API_URL = `https://p.hifellows.com/api/v1/`
const instance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export default instance;



